<script>
  /* global agGrid */
  import GRID_LOCALE_CS from '../../js/gridLocaleCs.js';
  import GRID_LOCALE_EN from '../../js/gridLocaleEn.js';
  import { onMount } from 'svelte';

  export let value;
  export let lang = undefined;
  export let mode = undefined;

  let rosterCoachesElement;

  let gridOptions;

  function getOptions () {
    return {
      theme: 'legacy',
      defaultColDef: {
        width: 90,
        sortable: true,
        filter: true,
        filterParams: {
          maxNumConditions: 1,
          filterOptions: ['contains'],
        },
      },
      columnDefs: [
        {
          headerName: lang !== 'en' ? 'Trenér' : 'Coach',
          // eslint-disable-next-line no-magic-numbers
          openByDefault: window.innerWidth > 800,
          children: [
            {
              field: 'number',
              headerName: '##',
              width: 45,
              cellDataType: 'number',
              type: 'numericColumn',
              pinned: true,
              filter: false,
              valueFormatter: params => params.value || '—',
            },
            {
              field: 'lastName',
              headerName: lang !== 'en' ? 'Příjmení' : 'Last name',
              width: 135,
              pinned: true,
              cellStyle: { fontWeight: 'bold' },
            },
            {
              field: 'firstName',
              headerName: lang !== 'en' ? 'Jméno' : 'First name',
              width: 135,
              pinned: true,
              columnGroupShow: 'open',
            },
          ],
        },
        {
          field: 'position',
          headerName: lang !== 'en' ? 'Pozice' : 'Position',
          width: 135,
        },
        {
          flex: 1,
          filter: false,
          sortable: false,
          suppressMovable: true,
        },
      ],
      animateRows: true,
      accentedSort: true,
      domLayout: 'autoHeight',
      rowData: value,
      localeText: lang !== 'en' ? GRID_LOCALE_CS : GRID_LOCALE_EN,
    };
  }

  onMount(() => {
    gridOptions = getOptions();

    gridOptions.api = agGrid.createGrid(rosterCoachesElement, gridOptions);
  });

  $: if (gridOptions && lang) {
    gridOptions.api.destroy();
    gridOptions = getOptions();

    gridOptions.api = agGrid.createGrid(rosterCoachesElement, gridOptions);
  }
</script>

<div class='roster-coaches ag-theme-balham' bind:this={rosterCoachesElement}
  class:ag-theme-balham-dark={mode !== 'light'}/>

<style>
  .roster-coaches {
    width: 100%;
    height: 100%;
  }

  :global(.ag-root-wrapper) {
    border-radius: 5px;
  }
</style>
